// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f86d42e","453":"74eab0ba","455":"fc475889","977":"6ca32781"}[chunkId] + ".chunk.js";
};